import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import {
    Label,
    Modal,
    Input
} from "reactstrap"

import {
    getMultipleCountryList as onGetMultipleCountryList,
    changeMultipleCountryList as onChangeMultipleCountryList,
    // changeMadridSearchSettingsCountry as onChangeMadridSearchSettingsCountry,
    // changeFilerSearchSettingsCountry as onChangeFilerSearchSettingsCountry,
} from "../../store/actions";
import { cloneDeep } from 'lodash';
import { Link } from "react-router-dom";

const SelectGlobalFirmBranch = props => {
    const dispatch = useDispatch();
    const { countryList, domainInfo, onCountryChange, index } = props;
    const [modal_standard, setmodal_standard] = useState(false);

    const openCountryModal = (flag) => {
        const selectedBranches = domainInfo.branch ? domainInfo.branch.split(', ') : [];

        if (flag) {
            countryList.map((c) => {
                if (c.crCode && selectedBranches.includes(c.crCode)) {
                    c.checked = true;
                    c.show = true;
                } else {
                    c.checked = false;
                    c.show = true;
                }
            })
        } else {
            countryList.map((c) => {
                c.checked = false;
                c.show = true;
            })
        }
        dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
        setmodal_standard(!modal_standard);
        removeBodyCss();
    }

    const search = (keyword) => {
        countryList.map((c) => {
            if (c.crCode.toLowerCase().includes(keyword) == true || (c.crName && c.crName.toLowerCase().includes(keyword) == true)) {
                c.show = true;
            } else {
                c.show = false;
            }
        })
        dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
    }

    const countryCheck = (code, checked) => {
        countryList.map((c) => {
            if (c.crCode == code) {
                c.checked = checked;
            }
        })
        dispatch(onChangeMultipleCountryList(cloneDeep(countryList)));
    }

    const countryConfirm = () => {
        let selectedCountries = [];
        countryList.map((c) => {
            if (c.checked) {
                selectedCountries.push(c.crCode);
            }
        })
        onCountryChange(index, selectedCountries.join(", "))
        setmodal_standard(false);
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    return (
        <>
            <div style={
                {display: 'flex', alignItems: 'center', gap: '2px', border: "1px solid #ddd", borderRadius: "4px", padding: "0px 4px 0px 0px",}
            }>
                <Input 
                    className="form-control"
                    type="text"
                    placeholder="Select country"
                    readOnly
                    style={{border: "none", outline: "none", flex: 1,}}
                    onChange={() => { }}
                    value={domainInfo.branch}
                />
                <Link to="#" onClick={(e) => openCountryModal(true)}> 
                    <i className="uil uil-plus-square font-size-22"></i>
                </Link>
            </div>
            <Modal
                isOpen={modal_standard}
                toggle={() => {
                    openCountryModal(false)
                }}
                scrollable={true}
            >
                <div className="modal-header" style={{ marginRight: "20px" }}>
                    <h5 className="modal-title mt-0" id="myModalLabel">
                        Select countries
                    </h5>
                    <div className="app-search" style={{ padding: '0' }}>
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control"
                                style={{ border: "solid 1px" }}
                                placeholder="Search..."
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        search(e.target.value); // check
                                    }
                                }}
                            />
                            <span className="uil-search"></span>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={() => {
                            openCountryModal(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {
                        countryList && countryList.length &&
                        countryList.map((c, index) => {
                            return (
                                c.show ?
                                    <div className="form-check mb-2" key={c.crCode}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={c.crCode}
                                            checked={c.checked}
                                            onClick={(e) => countryCheck(c.crCode, e.target.checked, false)}
                                        />
                                        <Label
                                            className="form-check-label"
                                            htmlFor={c.crCode}
                                        >
                                            {c.crCode} {c.crName}
                                        </Label>
                                    </div>

                                    : null
                            )
                        })
                    }
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        onClick={() => {
                            openCountryModal(false)
                        }}
                        className="btn btn-secondary waves-effect"
                        data-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={() => countryConfirm()}
                    >
                        Confirm
                    </button>
                </div>
            </Modal>
        </>
    )
};

export default SelectGlobalFirmBranch;